import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPosts } from "../../redux/slices/postSlice";
import PostRow from "./PostRow";
import { useTranslation } from "react-i18next";
import SockJS from "sockjs-client";

const WS_HTTP_URL = "https://miracleapi.com/websocket";

const PostTable = ({ onPostClick, tableMode, refreshTrigger, formState }) => {
  const { t } = useTranslation();
  const user = useSelector((state) => state.user.user);
  const dispatch = useDispatch();
  const posts = useSelector((state) => state.posts.posts);

  const [wsStatus, setWsStatus] = useState("disconnected"); // connected | connecting | disconnected
  const [wsError, setWsError] = useState("");

  useEffect(() => {
    dispatch(fetchPosts(0));
  }, [dispatch, refreshTrigger, formState]);

  useEffect(() => {
    setWsStatus("connecting");
    setWsError("");

    const sock = new SockJS(WS_HTTP_URL);

    window.sock = sock;

    sock.onopen = () => {
      setWsStatus("connected");
      console.log("[SockJS] open");
      try {
        sock.send(JSON.stringify({ type: "ping", ts: Date.now() }));
      } catch (e) {
        console.warn("[SockJS] send error:", e);
      }
    };

    sock.onmessage = (e) => {
      console.log("[SockJS] message:", e?.data);
    };

    sock.onclose = (e) => {
      setWsStatus("disconnected");
      console.log("[SockJS] close:", e);
    };

    sock.onerror = (e) => {
      setWsStatus("disconnected");
      setWsError("SockJS error (see console)");
      console.error("[SockJS] error:", e);
    };

    return () => {
      try { sock.close(); } catch {}
    };
  }, []);

  let filteredPosts = posts
    .filter((post) => post.status === "CREATED")
    .filter((post) =>
      tableMode === "buy"
        ? post.user_id !== user.data.id
        : post.user_id === user.data.id
    );
    console.log('filteredPosts',filteredPosts);
  if (formState?.sellCurrency && formState?.buyCurrency) {
    filteredPosts = filteredPosts.filter(
      (post) =>
        post.primary_currency === formState.sellCurrency &&
        post.secondary_currency === formState.buyCurrency
    );
  }

  const StatusDot = ({ status }) => {
    const label =
      status === "connected" ? "Connected" :
      status === "connecting" ? "Connecting..." : "Disconnected";
    const color =
      status === "connected" ? "#22c55e" :
      status === "connecting" ? "#eab308" : "#6b7280";
    return (
      <span className="ms-2 d-inline-flex align-items-center">
        <span
          style={{ width: 10, height: 10, borderRadius: "50%", background: color, display: "inline-block", marginRight: 6 }}
        />
        <small className="text-muted">{label}</small>
      </span>
    );
  };

  return (
    <div className="row">
      <div className="col-xl-12">
        <div className="card">
          <div className="card-header border-0 d-flex align-items-center">
            <h4 className="card-title mb-0">
              {tableMode === "buy" ? t("posts.available.label") : t("all.my.posts.label")}
            </h4>
            <StatusDot status={wsStatus} />
            {wsError && <small className="text-danger ms-2">({wsError})</small>}
          </div>
          <div className="card-body pt-0">
            <div className="transaction-table">
              <div className="table-responsive">
                <table className="table mb-0 table-responsive-sm">
                  {filteredPosts.length > 0 ? (
                    filteredPosts.map((post) => (
                      <PostRow
                        key={post.id}
                        primaryCurrency={post.primary_currency}
                        secondaryCurrency={post.secondary_currency}
                        account={post.default_card || post.default_bank || "Unknown Source"}
                        amount={post.amount}
                        rate={post.rate}
                        post={post}
                        onClick={(mode) => onPostClick(post, mode)}
                      />
                    ))
                  ) : (
                    <tbody>
                      <tr>
                        <td colSpan="6" className="text-center text-muted py-4">
                          {t("no.available.posts.label")}
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostTable;
